module.exports = __webpack_public_path__ + "static/media/no_orders_person.ca088da7.png";